import React, { Component } from 'react'
import EnrollmentPV from './EnrollmentPV'
import AuthA from '../../store/actions/AuthA'

import {connect} from 'react-redux'

class EnrollmentPC extends Component {
  state = {}

  logout = () => { this.props.authFn.logout()}

  render() {
    return (
      <EnrollmentPV
        auth={this.props.auth}
        logout={this.logout}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    loginErr: state.AuthR.loginErr,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EnrollmentPC);
